import { render, staticRenderFns } from "./nonlogin.vue?vue&type=template&id=4d60d4d7&scoped=true&"
import script from "./nonlogin.vue?vue&type=script&lang=js&"
export * from "./nonlogin.vue?vue&type=script&lang=js&"
import style0 from "./nonlogin.vue?vue&type=style&index=0&id=4d60d4d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60d4d7",
  null
  
)

export default component.exports